import Icon from '../components/Icon.vue'

Icon.register({
  'reply-all': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M136.3 189.8L312.3 37.9C327.7 24.5 352 35.3 352 56V138.8C481.2 149 576 191 576 322.3 576 383.8 536.4 444.6 492.7 476.5 479 486.4 459.6 473.9 464.6 457.8 503.1 334.7 460.7 288.3 352 275.8V360C352 380.7 327.7 391.4 312.3 378.2L136.3 226.2C125.2 216.6 125.2 199.4 136.3 189.8zM8.3 226.2L184.3 378.1C199.7 391.4 224 380.7 224 360V344.2L115.4 250.4A56-56 0 0 0 96 208 56-56 0 0 0 115.4 165.6L224 71.8V56C224 35.3 199.7 24.5 184.3 37.9L8.3 189.8C-2.8 199.4-2.8 216.6 8.3 226.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/reply-all.js
// module id = LHNx
// module chunks = 144